import React from 'react';
import { Link } from 'react-router-dom';
import BrandMark from '../common/BrandMark';
import { brand } from '../../data/siteContent';
import './Footer.css';

export default function FooterNew() {
  return (
    <footer className="ct-footer">
      <div className="container">
        <div className="ct-footer-grid">
          <div className="ct-footer-brand">
            <span className="ct-footer-logo">
              <BrandMark size={30} />
              <span>
                <span className="ct-logo-credit">CrediTools</span>
                <span className="ct-logo-mx">MX</span>
              </span>
            </span>
            <p className="ct-footer-tagline">{brand.tagline}</p>
            <p>Optimización tecnológica, automatización de reportes y herramientas internas para empresas que necesitan más claridad operativa.</p>
          </div>
          <div className="ct-footer-links">
            <h4>Navegación</h4>
            <Link to="/">Inicio</Link>
            <Link to="/soluciones">Soluciones</Link>
            <Link to="/herramientas">Herramientas</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/casos-de-exito">Casos de éxito</Link>
            <Link to="/contacto">Contacto</Link>
          </div>
          <div className="ct-footer-links">
            <h4>Legal</h4>
            <Link to="/aviso-privacidad">Aviso de Privacidad</Link>
            <Link to="/cookies">Política de Cookies</Link>
            <Link to="/terminos">Términos y Condiciones</Link>
            <Link to="/devoluciones">Cancelaciones y reembolsos</Link>
          </div>
          <div className="ct-footer-links">
            <h4>Contacto</h4>
            <a href="mailto:contacto@creditools.com.mx">contacto@creditools.com.mx</a>
            <a href="https://wa.me/529903888082" target="_blank" rel="noreferrer">+52 990 388 8082</a>
            <Link to="/contacto?intent=diagnostico">Agenda un diagnóstico de 15 minutos</Link>
          </div>
        </div>
        <div className="ct-footer-bottom">
          <p>© {new Date().getFullYear()} {brand.name}. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
